import { Route } from '@angular/router';
import { RenderEngineComponent } from '@app/pages/render-engine/render-engine.component';

export const BRAND_STORE_ROUTES: Route[] = [
  {
    path: '',
    component: RenderEngineComponent,
  },
  {
    path: ':brandId',
    component: RenderEngineComponent,
  },
];
